interface VerificationCodeParams {
  code: string;
}

export const verificationCodeEmail = ({ code }: VerificationCodeParams) => ({
  subject: "Your Data Revival verification code",
  html: `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
      </head>
      <body style="margin: 0; padding: 0; background-color: #f3f4f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background-color: #f3f4f6;">
          <tr>
            <td align="center" style="padding: 40px 20px;">
              <table role="presentation" width="600" cellspacing="0" cellpadding="0" style="max-width: 600px; width: 100%;">

                <!-- Header -->
                <tr>
                  <td align="center" style="padding-bottom: 32px;">
                    <img src="https://app.data-revival.com/DataRevival_FC_RGB.png" alt="Data Revival" height="32" style="display: block;">
                  </td>
                </tr>

                <!-- Main Card -->
                <tr>
                  <td style="background-color: #ffffff; border-radius: 12px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
                    <table role="presentation" width="100%" cellspacing="0" cellpadding="0">

                      <!-- Card Content -->
                      <tr>
                        <td style="padding: 40px 40px 24px 40px;">
                          <h1 style="margin: 0 0 16px 0; font-size: 24px; font-weight: 600; color: #111827; line-height: 1.3;">
                            Verify your email
                          </h1>
                          <p style="margin: 0; font-size: 16px; color: #4b5563; line-height: 1.6;">
                            Use the code below to complete your Data Revival sign up.
                          </p>
                        </td>
                      </tr>

                      <!-- Code Box -->
                      <tr>
                        <td align="center" style="padding: 0 40px 24px 40px;">
                          <div style="background-color: #f3f4f6; border-radius: 8px; padding: 24px; text-align: center;">
                            <span style="font-size: 40px; font-weight: 700; letter-spacing: 0.4em; color: #1d365d; font-family: monospace;">${code}</span>
                          </div>
                        </td>
                      </tr>

                      <!-- Notice -->
                      <tr>
                        <td style="padding: 0 40px 40px 40px;">
                          <p style="margin: 0 0 8px 0; font-size: 14px; color: #6b7280; line-height: 1.6;">
                            This code expires in 10 minutes. Do not share it with anyone.
                          </p>
                          <p style="margin: 0; font-size: 14px; color: #6b7280; line-height: 1.6;">
                            If you didn't request this, you can safely ignore this email.
                          </p>
                        </td>
                      </tr>

                    </table>
                  </td>
                </tr>

                <!-- Footer -->
                <tr>
                  <td style="padding: 32px 20px; text-align: center;">
                    <p style="margin: 0 0 8px 0; font-size: 14px; color: #6b7280; line-height: 1.5;">
                      Best regards,<br>
                      The Data Revival Team
                    </p>
                    <p style="margin: 16px 0 0 0; font-size: 12px; color: #9ca3af;">
                      &copy; ${new Date().getFullYear()} Data Revival Ltd. All rights reserved.
                    </p>
                  </td>
                </tr>

              </table>
            </td>
          </tr>
        </table>
      </body>
    </html>
  `,
  text: `Your Data Revival verification code is: ${code}

This code expires in 10 minutes. Do not share it with anyone.

If you didn't request this, you can safely ignore this email.

Best regards,
The Data Revival Team

© ${new Date().getFullYear()} Data Revival Ltd. All rights reserved.`,
});
